import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { changeLanguage } from '../../../@store/app.actions';
import { selectAvailableLanguages, selectCurrentLanguage } from '../../../@store/app.selectors';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSwitcherComponent {
  public selectedLanguage$ = this.store.select(selectCurrentLanguage);
  public availableLanguages$ = this.store.select(selectAvailableLanguages);

  constructor(private store: Store) {}

  public switchLanguage(lang: string) {
    this.store.dispatch(changeLanguage({ language: lang }));
  }

  public getLanguageName(lang: string | null) {
    switch (lang) {
      case 'he':
        return 'עברית';
      case 'en':
        return 'English';
      default:
        return lang;
    }
  }
}
